import * as React from 'react'
import { default as MuiListItem, ListItemProps } from '@mui/material/ListItem'

const ListItem = (props: ListItemProps) => {
  return <MuiListItem {...props} />
}

export default ListItem
